var Poll = {
	vote: function(poll_id, answer) {
		Api.post('/polls/vote', {poll_id: poll_id, answer: answer}, function(r){
			if(r.success){
				Alert.push([{type: 'success', text: 'Tu voto ha sido añadido con éxito. ¡Suerte!', icon: 'check'}]);
				$('#polls').remove();
			} else {
				switch(r.error.identifier){
					case 'choice_selected_not_allowed':
						Alert.push([{type: 'danger', text: '¡Oops! La opción que has seleccionado no es válida.', icon: 'triangle-alert'}]);
						break;
					case 'already_send_answer':
						Alert.push([{type: 'danger', text: '¡Oops! Ya has participado en esta encuesta.', icon: 'triangle-alert'}]);
						$('#polls').remove();
						break;
					case 'poll_not_allowed_at_time':
						Alert.push([{type: 'danger', text: '¡Oops! Esta encuesta aún no está disponible.', icon: 'triangle-alert'}]);
						$('#polls').remove();
						break;
					case 'poll_not_found':
						Alert.push([{type: 'danger', text: '¡Oops! Esta encuesta no existe o no está más disponible.', icon: 'triangle-alert'}]);
						$('#polls').remove();
						break;
				}
			}
		});
	}
}
